<template>
    <div>
        <el-form :model="servcOrder" :rules="checkServcOrder" ref="ruleForm" class="demo-ruleForm">
            <div class="block-container">
                <div class="content-caption dashed bg-white">
                    <span>合同信息</span>
                </div>
                <div class="form-single mt20 mb20">
                    <div class="title">选择合同</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 313px">
                            <el-input class="width-2x bottom-line" :disabled="true" v-model="servcOrder.contractName"></el-input>
                            <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="contractSelect"></i>
                        </div>
                    </div>
                </div>
                <div class="form-single mt20 mb20">
                    <div class="title">合同编号</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 313px">
                            <el-input class="width-2x bottom-line" :disabled="true" v-model="servcOrder.contractOriginalNo"></el-input>
                        </div>
                    </div>
                </div>

                <div v-if="contractId != null && trackPhaseList != null && trackPhaseList.length > 0" class="form-single mt20 mb20">
                    <div class="title required">选择合同阶段</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 313px">
                            <el-select placeholder="请选择" class="fl" v-model="trackPhaseId">
                                <el-option v-for="trackPhase in trackPhaseList" :key="trackPhase.id" :label="trackPhase.name" :value="trackPhase.id"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>

                <div class="content-caption dashed bg-white">
                    <span>服务信息</span>
                </div>
                <table class="custom-tbl">
                    <thead class="head">
                    <tr class="row">
                        <th width="50">
                            <el-checkbox v-model="allChecked" @change="selectAll();"></el-checkbox>
                        </th>
                        <th width="" style="text-align: left">名称</th>
                        <th width="80" style="text-align: right">质保期(天)</th>
                        <th width="80" style="text-align: right">上门费(元)</th>
                        <th width="80" style="text-align: right">工时费(元)</th>
                        <th width="80" style="text-align: right">服务费(元)</th>
                        <th width="" style="text-align: left">固定规格说明</th>
                        <th width="120" style="text-align: right">响应时长(分钟)</th>
                        <th width="120" style="text-align: right">到达时长(分钟)</th>
                        <th width="120" style="text-align: right">完成时长(分钟)</th>
                        <th v-if="contractId != null" width="70" style="text-align: right">服务次数</th>
                        <th v-if="contractId != null" width="80" style="text-align: right">已服务次数</th>
                        <!--<th width="">服务商品分类</th>-->
                        <th width="" align="left">操作</th>
                    </tr>
                    </thead>
                    <tbody class="body" v-if="contractId != null">
                    <tr class="row" v-for="servOrderItem in servcOrder.servcOrderItemList">
                        <td>
                            <el-checkbox v-model="servOrderItem.checked" @change="selectMku(servOrderItem);"></el-checkbox>
                        </td>
                        <td style="text-align: left">{{servOrderItem.name}}</td>
                        <td style="text-align: right">{{servOrderItem.wrntPeriod}}</td>
                        <td style="text-align: right">
                            <span v-if="servOrderItem.msu.toDoorFee != null">{{parseFloat(servOrderItem.toDoorFee).toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </td>
                        <td style="text-align: right">
                            <span v-if="servOrderItem.msu.workHourFee != null">{{parseFloat(servOrderItem.msu.workHourFee).toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </td>
                        <td style="text-align: right">
                            <span v-if="servOrderItem.price != null">{{parseFloat(servOrderItem.price).toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </td>
                        <td style="text-align: left">{{servOrderItem.msu.fixedSpec}}</td>
                        <td style="text-align: right">{{servOrderItem.yqRspTimeMi || 0}}</td>
                        <td style="text-align: right">{{servOrderItem.yqArriveTimeMi || 0}}</td>
                        <td style="text-align: right">{{servOrderItem.yqRepairedTimeMi || 0}}</td>
                        <td style="text-align: right">{{servOrderItem.quantity || 0}}</td>
                        <td style="text-align: right">{{servOrderItem.usedQuantity || 0}}</td>
                        <!--<td>-->
                        <!--<p v-if="servOrderItem.goodsCatId != null">{{servOrderItem.goodsCatName}}</p>-->
                        <!--<div>-->
                        <!--<span class="swb-btn-link" @click="selectServcGoodsCat(servOrderItem.msu.servcId, servOrderItem.ssuId)">选择商品分类</span>-->
                        <!--</div>-->
                        <!--</td>-->
                        <td align="left"><a class="swb-btn-link" @click="removeMsu(servOrderItem.ssuId)">移除</a></td>
                    </tr>
                    <tr class="row">
                        <td colspan="13" class="display-none">
                            <div class="no-data">
                                <i class="icon iconfont icon-zanwushuju mr10" style="font-size: 58px;vertical-align: middle;"></i>
                                <span class="">暂无数据 . . .</span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                    <tbody class="body" v-else>
                    <tr class="row" v-for="servOrderItem in servcOrder.servcOrderItemList">
                        <td>
                            <el-checkbox el-checkbox v-model="servOrderItem.checked" @change="selectMku(servOrderItem);"></el-checkbox>
                        </td>
                        <td style="text-align: left">{{servOrderItem.title}}</td>
                        <td style="text-align: right">{{servOrderItem.wrntPeriod}}</td>
                        <td style="text-align: right" v-if="servOrderItem.toDoorFee != null">{{parseFloat(servOrderItem.toDoorFee).toFixed(2)}}</td>
                        <td style="text-align: right" v-if="servOrderItem.workHourFee != null">{{parseFloat(servOrderItem.workHourFee).toFixed(2)}}</td>
                        <td style="text-align: right" v-if="servOrderItem.generallFee != null">{{parseFloat(servOrderItem.generallFee).toFixed(2)}}</td>
                        <td style="text-align: left">{{servOrderItem.fixedSpec}}</td>
                        <td style="text-align: right">{{servOrderItem.yqRspTimeMi || 0}}</td>
                        <td style="text-align: right">{{servOrderItem.yqArriveTimeMi || 0}}</td>
                        <td style="text-align: right">{{servOrderItem.yqRepairedTimeMi || 0}}</td>
                        <!--<td>-->
                        <!--<p v-if="servOrderItem.goodsCatId != null">{{servOrderItem.goodsCatName}}</p>-->
                        <!--<div>-->
                        <!--<span class="swb-btn-link" @click="selectServcGoodsCat(servOrderItem.servcId, servOrderItem.ssuId)">选择商品分类</span>-->
                        <!--</div>-->
                        <!--</td>-->
                        <td><a class="swb-btn-link" @click="removeMsu(servOrderItem.ssuId)">移除</a></td>
                    </tr>
                    <tr class="row">
                        <td colspan="11" class="display-none">
                            <div class="no-data">
                                <i class="icon iconfont icon-zanwushuju mr10" style="font-size: 58px;vertical-align: middle;"></i>
                                <span class="">暂无数据 . . .</span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot class="foot">
                    <tr class="row" v-if="contractId == null">
                        <td colspan="11">
                            <div class="swb-btn-link" v-bind:style="{'pointer-events: none':isShow }" v-bind:class="{ 'swb-btn-disabled': isShow,'pointer-events: none':isShow }" @click="addServ">
                                    <span>
                                        <i class="icon iconfont icon-jiahao mr5"></i>选择服务
                                    </span>
                            </div>
                        </td>
                    </tr>
                    </tfoot>
                </table>

                <div class="form-single">
                    <div class="title required">选择零售商</div>
                    <div class="content">
                        <div class="pos-rel mb15" style="width: 313px">
                            <el-form-item prop="peerMerchantName">
                                <el-input class="width-2x bottom-line" :disabled="true" v-model="servcOrder.peerMerchantName"></el-input>
                                <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" v-if="contractId == null" @click="selectRetail"></i>
                            </el-form-item>

                        </div>
                    </div>
                </div>
                <div class="form-single mt20 mb20">
                    <div class="title required">零售商机构</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 313px">
                            <el-form-item prop="buyerShopName">
                                <el-input class="width-2x bottom-line" :disabled="true" v-model="servcOrder.buyerShopName"></el-input>
                                <!--<i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectShopRetail"></i>-->
                                <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectRetailOrg"></i>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="form-single mt20 mb20">
                    <div class="title">机构联系人</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 313px">
                            <el-input class="width-2x" v-model="servcOrder.buyerShopContactName"></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-single mt20 mb20">
                    <div class="title">机构电话</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 313px">
                            <el-input class="width-2x" v-model="servcOrder.buyerShopContactTel"></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-single mt20 mb20">
                    <div class="title">预约时间</div>
                    <div class="content">
                        <el-date-picker v-model="planTime" type="datetime" placeholder="选择日期" format="yyyy-MM-dd HH:mm"></el-date-picker>
                    </div>
                </div>
                <div v-if="contractId == null">
                    <div class="form-single mt20 mb20">
                        <div class="title required">是否开发票</div>
                        <el-radio-group v-model="invoiceClaimed">
                            <el-radio :label="false">否</el-radio>
                            <el-radio :label="true">是</el-radio>
                        </el-radio-group>
                    </div>
                    <div v-if="invoiceClaimed == true">
                        <!--<div class="form-single mt20 mb20">
                            <div class="title required">发票主体类型</div>
                            <ul class="enum-list">
                                <li v-for="(invoiceSubjectType,index) in invoiceSubjectTypeList" class="enum-item" v-bind:class="{checked: servcOrder.invoiceSubjectType ==invoiceSubjectType.value}" v-model="invoiceSubjectType.value" @click="changInvoiceSubjectType(invoiceSubjectType,index)">
                                    <span>{{invoiceSubjectType.text}}</span>
                                    <i></i>
                                </li>
                            </ul>
                        </div>-->
                        <div class="form-single mt20 mb20">
                            <div class="title required">发票类型</div>
                            <div class="content">
                                <ul class="enum-list">
                                    <li v-for="(invoiceType,index) in invoiceTypeList" class="enum-item" v-bind:class="{checked: servcOrder.invoiceType ==invoiceType.value}" v-model=" invoiceType.value" @click="changInvoiceTypeType(invoiceType,index)">
                                        <span>{{invoiceType.name}}</span>
                                        <i></i>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="form-single mt20 mb20">
                            <div class="title required">发票内容标签</div>
                            <div class="content">
                                <ul class="enum-list">
                                    <li v-for="(invoiceContentTag,index) in invoiceContentTagList" class="enum-item" v-bind:class="{checked: servcOrder.invoiceContentTag ==invoiceContentTag.name}" v-model=" invoiceContentTag.value" @click="changInvoiceContentTag(invoiceContentTag,index)">
                                        <span>{{invoiceContentTag.name}}</span>
                                        <i></i>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="form-single mt20 mb20">
                            <div class="title required">发票抬头</div>
                            <div class="content">
                                <div class="pos-rel" style="width: 313px">
                                    <el-input class="width-2x bottom-line" v-model="servcOrder.invoiceTitle"></el-input>
                                </div>
                            </div>
                        </div>
                        <div class="form-single mt20 mb20">
                            <div class="title required">纳税人识别号</div>
                            <div class="content">
                                <div class="pos-rel" style="width: 313px">
                                    <el-input class="width-2x bottom-line" v-model="servcOrder.taxPayerNo"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="content-caption dashed bg-white">
                        <span>支付信息</span>
                    </div>
                    <div class="form-single mt20 mb20">
                        <div class="title required">付款时机</div>
                        <div class="content">
                            <ul class="enum-list">
                                <li v-for="(payTiming,index) in payTimingList" class="enum-item" v-bind:class="{checked: servcOrder.payTiming ==payTiming.value }" v-model="servcOrder.payTiming" @click="changPayTiming(payTiming,index)">
                                    <span>{{payTiming.name}}</span>
                                    <i></i>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="form-single">
                        <div class="title required">支付方式</div>
                        <div class="content">
                            <ul class="enum-list">
                                <!--<li class="enum-item checked" v-model="servcOrder.payWay">
                                    <span>银联</span>
                                    <i></i>
                                </li>-->
                                <li v-for="(payWay,index) in payWayList" class="enum-item" v-bind:class="{checked: servcOrder.payWay ==payWay.value }" v-model="servcOrder.payWay" @click="changPayWay(payWay,index)">
                                    <span>{{payWay.name}}</span>
                                    <i></i>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="form-single mt20 mb20">
                    <div class="title">故障描述</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 600px">
                            <el-input type="textarea" class="width-1-5x bottom-line" :rows="3" placeholder="故障描述最大长度120个字" :maxlength="120" v-model="servcOrder.troubleDesc"></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-single mt20 mb20">
                    <div class="title">附言</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 600px">
                            <el-input type="textarea" class="width-1-5x bottom-line" :rows="3" placeholder="附言最大长度120个字" :maxlength="120" v-model="servcOrder.postscript"></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-single mt20 mb20">
                    <div class="title required">预计交易总金额</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 313px">
                            <el-form-item prop="totalAmount">
                                <el-input class="width-2x bottom-line" disabled v-model="servcOrder.totalAmount"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </div>
        </el-form>
        <div class="form-toolbar">
            <button class="swb-btn swb-btn-small" @click="submitClick">提交</button>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { openRetailComTreeSelectDlg, openRetailerSelectComnDlg } from '../retailer/selectDlg';
    import{ selectRedioServcGoodsCatRel } from '../servc/selectDlg';

    import userApi from '../../api/user'
    import contractApi from '../../api/contract'
    import merchtFinacApi from '../../api/merchtFinac'
    import merchtQualiApi from '../../api/merchtQuali'
    import servcOrderApi from '../../api/servcOrder'
    import servcApi from '../../api/servc'

    import SwbContractListForSelect from '../contract/ContractListForSelect';
    Vue.regist(SwbContractListForSelect);

    import SwbContractServcListForSelect from '../contract/ContractServcListForSelect';
    Vue.regist(SwbContractServcListForSelect);

    import SwbMsuListForSelect from '../servc/MsuListForSelect';
    Vue.regist(SwbMsuListForSelect);

    import SwbMerchantBizRelSelect from '../merchant/MerchantBizRelSelect';
    Vue.regist(SwbMerchantBizRelSelect);

    import SwbRetailerComListForSelect from '../retailer/RetailerComListForSelect';
    Vue.regist(SwbRetailerComListForSelect);

    import SwbServcOrderIsSelfList from './ServcOrderIsSelfList';
    Routes.add(SwbServcOrderIsSelfList);

    import SwbContractServcOrderList from './ContractServcOrderList';
    Routes.add(SwbContractServcOrderList);

    export default {
        name: 'swb-servc-order-create',
        path: '/servc/order/create',
        avlActions: '',
        avlActionNames: '提交',
        avlScopes: 'servicer',
        notAsResc: false,
        authen: false,
        desc: '服务代理下单',
        helpArticleCode: 'servicer-servc-order-create',
        data: function () {
            let checkRetail = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('零售商不能为空'));
                } else {
                    callback();
                }
            };
            let checkRetailShop = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('零售商机构不能为空'));
                } else {
                    callback();
                }
            };
            let checkTotalAmount = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入总金额'));
                } else {
                    if(!Utils.isMoneyStr(value)) {
                        callback(new Error('必须是金额'));
                    } else {
                        callback();
                    }
                }
            };
            return {
                servcOrder: {
                    servcOrderItemList: [],
                    contractId: null,
                    contractName: null,
                    contractOriginalNo: null,
                    contractNo: null,
                    peerMerchantName: null,
                    buyerShopId: null,
                    buyerShopName: null,
                    buyerShopContactTel: null,
                    buyerShopContactName: null,
                    buyerType: null,
                    buyerId: null,
                    payTiming: null,
                    payWay: null,
                    recvFrame: 0,
                    invoiceType: null,
                    invoiceSubjectType: 1,
                    invoiceTitle: null,
                    invoiceContentTag: null,
                    taxPayerNo: null,
                    totalAmount: 0.00,
                    postscript: null,
                    troubleDesc: null
                },
                trackPhaseId: null,
                trackPhaseList: [],
                planTime: new Date(),
                contractId: null,
                //发票信息
                invoiceClaimed: false,
                //
                payWayList: [],
                payTimingList: [],
                recvFrameList: [],
                invoiceTypeList: [],
                invoiceSubjectTypeList: [],
                invoiceContentTagList: [],
                //
                plain: null,
                //
                allChecked: false,
                isShow: false,

                checkServcOrder: {
                    peerMerchantName: [{
                        validator: checkRetail,
                        trigger: 'change'
                    }],
                    shopRetailName: [{
                        validator: checkRetailShop,
                        trigger: 'change'
                    }],
                    totalAmount: [
                        {validator: checkTotalAmount, trigger: 'blur'}
                    ],
                }
            }
        },
        watch: {
            contractId: function (newValue, oldValue) {
                if(newValue != oldValue) {
                    this.getContractServcPageList();
                } else {

                }
            }
        },
        created: function () {
            let self = this;
            //发票信息
            self.selectPayWay();
            self.selectInvoiceCtntTag();
            self.selectPayTiming();
            self.selectInvoiceType();
            self.recvFrameList = getEnumList('recvFrame', true);
            self.invoiceSubjectTypeList = getEnumList('invoiceSubjectType', true);
            //
            let postData = {};
            userApi.getUserInfoByContext(postData, function (result) {
                if(result.type == 'info') {
                    self.data = result.data;
                } else {
                    self.$message.error(result.message);
                }
            });
            let contractId = this.$route.query.contractId || null;
            self.servcOrder.contractId = contractId;
            self.contractId = contractId;
            if(!Utils.isNoB(contractId)) {
                self.getContractServcList();
                self.getContractTrackPhase(contractId);
            }
        },
        methods: {
            getContractServcList: function () {
                let self = this;
                let postData = {};
                let servcOrder = self.servcOrder;
                postData.id = servcOrder.contractId;
                let loading = MsgBox.loading();
                contractApi.getContractInfo(postData, function (result) {
                    if(result.type == "info") {
                        let data = result.data;
                        if(data.curValid) {
                            servcOrder.curValid = data.curValid;
                            servcOrder.contractName = data.title;
                            servcOrder.contractOriginalNo = data.originalNo;
                            servcOrder.contractNo = data.no;
                            servcOrder.peerMerchantName = data.fstPartyName;
                            servcOrder.sellerId = data.sndPartyId;
                            servcOrder.sellerType = data.sndPartyType;
                            servcOrder.sellerName = data.sndPartyName;
                            servcOrder.buyerId = data.fstPartyId;
                            servcOrder.buyerName = data.fstPartyName;
                            servcOrder.buyerType = data.fstPartyType;
                            servcOrder.payWay = data.payWay;
                            servcOrder.invoiceType = data.invoiceType;
                            servcOrder.invoiceTitle = data.invoiceTitle;
                            servcOrder.invoiceContentTag = data.invoiceContentTag;
                            servcOrder.curValid = data.curValid;
                            servcOrder.taxPayerNo = data.taxPayerNo;
                            let servcOrderItemList = [];
                            for(let i = 0; i < data.contractServcList.length; i++) {
                                let contractServc = data.contractServcList[i];
                                contractServc.contractItemId = contractServc.id;
                                contractServc.checked = false;
                                contractServc.yqRspTimeMi = contractServc.rspTimeMi;
                                contractServc.yqArriveTimeMi = contractServc.arriveTimeMi;
                                contractServc.yqRepairedTimeMi = contractServc.repairedTimeMi;
                                servcOrderItemList.push(contractServc);
                            }
                            servcOrder.contractType = getEnumInfoWith("contractType", "value", data.typeId);
                            self.getContractServcPageList();
                            servcOrder.servcOrderItemList = servcOrderItemList;
                            self.servcOrder = Utils.merge({}, servcOrder);
                            loading.close();
                        } else {
                            loading.close();
                            MsgBox.warning("请选择有效的合同");
                            return false;
                        }

                    } else {
                        MsgBox.warning(result.message);
                        return false;
                    }
                });
            },
            //选择合同信息
            contractSelect: function () {
                let self = this;
                let servcOrder = self.servcOrder;
                Vue.$showDialog({
                    title: '合同 - 选择',
                    showCloseBtn: true,
                    width: '70%',
                    height: '80%',
                    template: '<div>' +
                    '<swb-contract-list-for-select :contractType="contractType" :contractTypeList="contractTypeList" ref="swb_contract_list_select"></swb-contract-list-for-select>' +
                    '</div>',
                    data: {
                        contractType: null,
                        contractTypeList: null,
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_contract_list_select.getDlgResult() || {};
                        if(result != null && result.type === 'info') {
                            let contract = result.data;
                            if(contract != null) {
                                servcOrder.contractId = contract.id;
                                servcOrder.contractOriginalNo = contract.originalNo;
                                servcOrder.contractNo = contract.No;
                                servcOrder.contractName = contract.title;
                                servcOrder.peerMerchantName = contract.fstPartyName;
                                servcOrder.buyerType = contract.fstPartyType;
                                servcOrder.buyerId = contract.fstPartyId;
                                servcOrder.payWay = contract.payWay;
                                servcOrder.invoiceType = contract.invoiceType;
                                servcOrder.invoiceTitle = contract.invoiceTitle;
                                servcOrder.invoiceContentTag = contract.invoiceContentTag;
                                servcOrder.taxPayerNo = contract.taxPayerNo;
                                self.contractId = contract.id;
                                servcOrder.buyerShopId = null;
                                servcOrder.buyerShopName = null;
                                servcOrder.buyerShopContactTel = null;
                                servcOrder.buyerShopContactName = null;
                                self.isShow = true;
                                servcOrder.totalAmount = 0.00;
                                self.allChecked = false;
                                self.servcOrder = Utils.merge({}, servcOrder);

                                // 获取合同阶段
                                self.getContractTrackPhase(self.contractId);
                                return true;
                            }
                        } else {
                            MsgBox.warning(result.message);
                            return false;
                        }
                    },
                    lifecycle: {
                        created: function () {
                            let contractType = getEnumInfoWith('contractType', 'name', 'ServcPurch');
                            this.contractType = contractType.value;
                        }
                    }
                });
            },
            // 获取合同阶段
            getContractTrackPhase: function (contractId) {
                let self = this;
                self.trackPhaseId = null;
                let params = {};
                params.contractId = contractId;
                contractApi.getContractTrackPhaseListByContractId(params, function (reault) {
                    if(reault.type == 'info') {
                        self.trackPhaseList = reault.data;
                        let trackPhaseList = self.trackPhaseList;
                        if(!Utils.isNoB(trackPhaseList) && trackPhaseList.length > 0) {
                            for(let i = 0; i < trackPhaseList.length; i++) {
                                let trackPhase = trackPhaseList[i];
                                if(trackPhase.active) {
                                    self.trackPhaseId = trackPhase.id;
                                }
                            }
                        }
                    } else {
                        MsgBox.warning(reault.message);
                    }
                })
            },
            //合同中服务项
            getContractServcPageList: function () {
                let self = this;
                let postData = {};
                postData.id = self.servcOrder.contractId;
                let loading = MsgBox.loading();
                contractApi.getContractInfo(postData, function (result) {
                    if(result.type == "info") {
                        let data = result.data || {};
                        let contractServcList = data.contractServcList || [];
                        let msuList = [];
                        for(let i = 0; i < contractServcList.length; i++) {
                            let contractServc = contractServcList[i];
                            let msu = contractServc;
                            msu.contractItemId = contractServc.id;
                            msu.checked = false;
                            msu.generallFee = contractServc.price;
                            msu.yqRspTimeMi = contractServc.rspTimeMi;
                            msu.yqArriveTimeMi = contractServc.arriveTimeMi;
                            msu.yqRepairedTimeMi = contractServc.repairedTimeMi;
                            msuList.push(msu);
                        }
                        self.servcOrder.servcOrderItemList = Utils.merge([], msuList);
                        loading.close();
                    } else {
                        loading.close();
                        MsgBox.warning(result.message);
                    }
                });
            },
            //选择全部的服务项
            selectAll: function () {
                let self = this;
                let servcOrderItemList = self.servcOrder.servcOrderItemList;
                if(self.allChecked) {
                    if(servcOrderItemList != null && servcOrderItemList.length > 0) {
                        let amount = 0;
                        for(let i = 0; i < servcOrderItemList.length > 0; i++) {
                            let servOrderItem = servcOrderItemList[i];
                            servOrderItem.checked = true;
                            let toDoorFee = servOrderItem.toDoorFee || 0;
                            if(!Utils.isNoB(self.contractId)) {
                                amount = (parseFloat(amount) + parseFloat(servOrderItem.price || 0) + parseFloat(servOrderItem.toDoorFee || 0));
                            } else {
                                amount = (parseFloat(amount) + parseFloat(servOrderItem.toDoorFee || 0));
                            }
                            servOrderItem.toDoorFee = toDoorFee;
                        }
                        self.servcOrder.totalAmount = amount.toFixed(2);

                    }
                    self.allChecked = true;
                } else {
                    if(servcOrderItemList != null && servcOrderItemList.length > 0) {
                        for(let i = 0; i < servcOrderItemList.length > 0; i++) {
                            let servOrderItem = servcOrderItemList[i];
                            servOrderItem.checked = false;
                            self.servcOrder.totalAmount = 0;
                            servOrderItem.toDoorFee = servOrderItem.toDoorFee || 0;
                        }
                    }
                    self.allChecked = false;
                }

                self.servcOrder.servcOrderItemList = Utils.merge([], servcOrderItemList);
            },
            //单选服务项
            selectMku: function (servOrderItem) {
                let self = this;
                self.isAllSelect();
                if(servOrderItem.checked) {
                    if(!Utils.isNoB(self.contractId)) {
                        self.servcOrder.totalAmount = (parseFloat(self.servcOrder.totalAmount || 0) + parseFloat(servOrderItem.price || 0) + parseFloat(servOrderItem.toDoorFee || 0)).toFixed(2);
                    } else {
                        self.servcOrder.totalAmount = (parseFloat(self.servcOrder.totalAmount || 0) + parseFloat(servOrderItem.toDoorFee || 0)).toFixed(2);
                    }
                } else {
                    if(!Utils.isNoB(self.contractId)) {
                        self.servcOrder.totalAmount = (parseFloat(self.servcOrder.totalAmount || 0) - parseFloat(servOrderItem.price || 0) - parseFloat(servOrderItem.toDoorFee || 0)).toFixed(2);
                    } else {
                        self.servcOrder.totalAmount = (parseFloat(self.servcOrder.totalAmount) - parseFloat(servOrderItem.toDoorFee || 0)).toFixed(2);
                    }
                    if(self.servcOrder.totalAmount < 0) {
                        self.servcOrder.totalAmount = 0;
                    }

                }
                self.msuList = Utils.merge([], self.servcOrder.servcOrderItemList);
            },
            //判断是否全选
            isAllSelect: function () {
                let self = this;
                let servcOrderItemList = self.servcOrder.servcOrderItemList;
                for(let i = 0; i < servcOrderItemList.length; i++) {
                    if(servcOrderItemList[i].checked == false) {
                        self.allChecked = false;
                        return false;
                    }
                }
                self.allChecked = true;
                return true;
            },
            //增加服务项，当合同为空时
            addServ: function () {
                let self = this;
                Vue.$showDialog({
                        title: "选择服务",
                        width: '80%',
                        height: 700,
                        showCloseBtn: true,
                        template: '<div >' +
                        '<swb-msu-list-for-select :checkBox="true" :objectId="objectId" :checkedIds="childEventList" :shelfState="shelfState" ref="swb_msu_list"></swb-msu-list-for-select>' +
                        '</div>',
                        data: {
                            childEventList: [],
                            shelfState: null,
                        },
                        okClicked: function () {
                            let selfDlg = this;
                            let result = selfDlg.$refs.swb_msu_list.getDlgResult() || {};
                            if(result !== null) {
                                if(result.type === 'info') {
                                    let servcOrderItemList = self.servcOrder.servcOrderItemList || [];
                                    let msuList = result.data || [];
                                    let selIds = servcOrderItemList.pluck("ssuId");
                                    let allIds = msuList.pluck("ssuId");
                                    let sameIds = Utils.compareArrays(selIds, allIds)['same'];
                                    for(let i = 0; i < msuList.length; i++) {
                                        let msu = msuList[i];
                                        if(sameIds.contains(msu.ssuId)) {
                                            msuList.splice(i, 1);
                                            i--;
                                        } else {
//                                            msu.goodsCatId = null;
//                                            msu.goodsCatName = null;
                                            msu.checked = false;
                                            msu.yqRspTimeMi = msu.rspTimeMi;
                                            msu.yqArriveTimeMi = msu.arriveTimeMi;
                                            msu.yqRepairedTimeMi = msu.repairedTimeMi;
                                        }
                                    }

                                    let concatMsuList = servcOrderItemList.concat(msuList);
                                    self.servcOrder.servcOrderItemList = Utils.merge([], concatMsuList);
                                    return true;
                                }
                            } else {
                                MsgBox.warning("返回出错");
                                return false;
                            }
                        },
                        methods: {},
                        lifecycle: {
                            created: function () {
//                                let selfDlg = this;
                                let servc = self.servcOrder.servcOrderItemList;
                                let msuIds = [];
                                if(servc && servc.length > 0) {
                                    for(var i = 0; i < servc.length; i++) {
                                        msuIds.push(servc[i].ssuId);
                                    }
                                }
                                this.childEventList = msuIds;
                                this.objectId = self.data.merchantId;
                                this.shelfState = getEnumInfoWith('shelfState', 'name', 'On').value;
                            }
                        }
                    }
                );
            },
            //删除服务项
            removeMsu: function (ssuId) {
                let self = this;
                let servcOrderItemList = self.servcOrder.servcOrderItemList || [];
                for(let i = 0; i < servcOrderItemList.length; i++) {
                    let servOrderItem = servcOrderItemList[i];
                    if(servOrderItem.ssuId == ssuId) {
                        self.servcOrder.servcOrderItemList.splice(i, 1);
                    }
                }
            },
            selectServcGoodsCat: function (servcId, ssuId) {
                let self = this;
                let servcOrderItemList = self.servcOrder.servcOrderItemList;
                selectRedioServcGoodsCatRel(servcId, function (result) {
                    let servcGoodsCatRel = result;
                    for(let i = 0; i < servcOrderItemList.length; i++) {
                        let servOrderItem = servcOrderItemList[i];
                        if(servOrderItem.ssuId == ssuId) {
                            servOrderItem.goodsCatId = servcGoodsCatRel.goodsCatId;
                            servOrderItem.goodsCatName = servcGoodsCatRel.goodsCatName;
                        }
                    }
                    self.servcOrder.servcOrderItemList = Utils.merge([], servcOrderItemList);
                    console.log(JSON.encode(self.servcOrder.servcOrderItemList));
                });

            },
            //当合同为空时选择零售商
            selectRetail: function () {
                let self = this;
                let params = {
                    multiSelect: false,
                    initCheckedId: self.servcOrder.buyerId,
                    showContract: true, // 合同
                    showOrder: true, // 订单
                    showBizRel: true, // 备选
                    showAdverseBizRel: true, // 买方关联，备选其他
                    showNoScoreBizRel: true, // 带入围
                    showShieldedBizRel: true // 加黑
                };
                openRetailerSelectComnDlg(params, function (result, theDlg) {
                    theDlg.close();
                    let retail = result.checkedList || {};
                    self.servcOrder.peerMerchantName = retail.name;
                    self.servcOrder.buyerId = retail.id;
                    self.servcOrder.buyerType = getEnumInfoWith('merchantType', 'name', 'Retailer').value;
                });
//                let servcOrder = self.servcOrder;
//                Vue.$showDialog({
//                        title: "选择零售商",
//                        showCloseBtn: true,
//                        template: '<div >' +
//                        '<swb-merchant-biz-rel-select :checkBox="false" :propMerchantType="propMerchantType":peerMerchantIds="peerMerchantIds" ref="swb_merchant_biz_rel_select_info"></swb-merchant-biz-rel-select>' +
//                        '</div>',
//                        data: {
//                            childEventList: [],
//                        },
//                        okClicked: function () {
//                            let selfDlg = this;
//                            let result = selfDlg.$refs.swb_merchant_biz_rel_select_info.getDlgResult() || {};
//                            if(result !== null) {
//                                if(result.type === 'info') {
//                                    let retail = result.data;
//                                    servcOrder.peerMerchantName = retail.peerMerchantName;
//                                    servcOrder.buyerId = retail.peerMerchantId;
//                                    servcOrder.buyerType = retail.peerMerchantType;
//                                    //
////                                    self.selectInvoiceSubject(retail.peerMerchantId, retail.peerMerchantType, self.servcOrder.invoiceType);
//                                    return true;
//                                }
//                            } else {
//                                MsgBox.warning("返回出错");
//                                return false;
//                            }
//                        },
//                        methods: {},
//                        lifecycle: {
//                            created: function () {
//                                let selfDlg = this;
//                                selfDlg.peerMerchantIds = self.servcOrder.fstPartyId;
//                                let merchantType = getEnumInfoWith('merchantType', 'name', 'Retailer');
//                                selfDlg.propMerchantType = merchantType.value;
//                            }
//                        }
//                    });
            },
            // 零售商门店标识功能弱化，选择门店改成选择机构
            selectRetailOrg(){
                let servcOrder = this.servcOrder;
                if(Utils.isNoB(servcOrder.buyerId)) {
                    MsgBox.warning("请选择零售商");
                    return;
                }
                let dlgConfig = {};
                dlgConfig.comId = this.servcOrder.buyerId;
                dlgConfig.isRadio = true;
                openRetailComTreeSelectDlg(dlgConfig, function (result) {
                    let shopRetail = result;
                    servcOrder.buyerShopId = shopRetail.id;
                    servcOrder.buyerShopName = shopRetail.name;
                    servcOrder.buyerShopContactTel = shopRetail.contactTel;
                    servcOrder.buyerShopContactName = shopRetail.contactName;
                });
            },
            //选择零售商门店
            selectShopRetail: function () {
                let self = this;
                let servcOrder = self.servcOrder;
                if(!Utils.isNoB(self.servcOrder.buyerId)) {
                    Vue.$showDialog({
                            title: "零售商机构 - 选择",
                            showCloseBtn: true,
                            template: '<div >' +
                            '<swb-retailer-com-list-for-select :checkBox="false" :filter="fiter":operatorComListIds="operatorComListIds" ref="swb_retailer_com_list"></swb-retailer-com-list-for-select>' +
                            '</div>',
                            data: {
                                filter: [],
                                operatorComListIds: [],
                            },
                            okClicked: function () {
                                let selfDlg = this;
                                let result = selfDlg.$refs.swb_retailer_com_list.getDlgResult() || {};
                                if(result !== null) {
                                    if(result.type === 'info') {
                                        let shopRetail = result.data;
                                        servcOrder.buyerShopId = shopRetail.id;
                                        servcOrder.buyerShopName = shopRetail.name;
                                        servcOrder.buyerShopContactTel = shopRetail.contactTel;
                                        servcOrder.buyerShopContactName = shopRetail.contactName;
                                        return true;
                                    }
                                } else {
                                    MsgBox.warning("返回出错");
                                    return false;
                                }
                            },
                            methods: {},
                            lifecycle: {
                                created: function () {
                                    let selfDlg = this;
                                    let filter = {};
                                    filter.merchantId = servcOrder.buyerId;
                                    filter.shopFlag = true;
                                    selfDlg.fiter = filter;
                                    selfDlg.operatorComListIds = servcOrder.buyerShopId;

                                }
                            }
                        }
                    );
                } else {
                    MsgBox.warning("请选择零售商");
                }

            },
            //商户（支持的）发票类型
            selectInvoiceType: function () {
                let self = this;
                let servcOrder = self.servcOrder;
                let postData = {};
                let loading = MsgBox.loading();
                merchtFinacApi.getMerchantInvoiceTypeListAvailable(postData, function (result) {
                    if(result.type == "info") {
                        let invoiceTypeList = result.data || [];
                        for(let i = 0; i < invoiceTypeList.length; i++) {
                            let invoiceType = invoiceTypeList[i];
                            if(invoiceType.defaulted) {
                                servcOrder.invoiceType = invoiceType.value;
                            }
                        }
                        self.invoiceTypeList = Utils.merge([], invoiceTypeList);
                        self.servcOrder = Utils.merge({}, servcOrder);
                        loading.close();
                    }
                })
            },
            //商户（支持的）付款时机
            selectPayTiming: function () {
                let self = this;
                let postData = {};
                let servcOrder = self.servcOrder;
                let loading = MsgBox.loading();
                merchtFinacApi.getMerchantPayTimingListAvailable(postData, function (result) {
                    if(result.type == "info") {
                        let payTimingList = result.data || [];
                        for(let i = 0; i < payTimingList.length; i++) {
                            let payTiming = payTimingList[i];
                            if(payTiming.defaulted) {
                                servcOrder.payTiming = payTiming.value;
                            }
                        }
                        self.payTimingList = Utils.merge([], payTimingList);
                        self.servcOrder = Utils.merge({}, servcOrder);
                        loading.close();
                    }
                })
            },
            //商户（支持的）付款方式
            selectPayWay: function () {
                let self = this;
                let postData = {};
                let loading = MsgBox.loading();
                merchtFinacApi.getEnabledMerchantPayWayList(postData, function (result) {
                    if(result.type == "info") {
                        let payWayList = result.data || [];
                        for(let i = 0; i < payWayList.length; i++) {
                            let payWay = payWayList[i];
                            if(payWay.defaulted) {
                                self.servcOrder.payWay = payWay.value;
                            }
                        }
                        self.payWayList = Utils.merge([], payWayList);
                        self.servcOrder = Utils.merge({}, self.servcOrder);
                        loading.close();
                    }
                })
            },
            //商户（支持的）发票内容标签
            selectInvoiceCtntTag: function () {
                let self = this;
                let postData = {};
                let servcOrder = self.servcOrder;
                let loading = MsgBox.loading();
                merchtFinacApi.getMerchantInvoiceCtntTagList(postData, function (result) {
                    if(result.type == "info") {
                        let invoiceContentTagList = result.data || [];
                        for(let i = 0; i < invoiceContentTagList.length; i++) {
                            let invoiceContentTag = invoiceContentTagList[i];
                            if(invoiceContentTag.defaulted) {
                                servcOrder.invoiceContentTag = invoiceContentTag.name;
                            }
                        }
                        self.invoiceContentTagList = Utils.merge([], invoiceContentTagList);
                    }
                    self.servcOrder = Utils.merge({}, servcOrder);
                    loading.close();
                })
            },

            //选择发票方式
            //选择支付方式
            changPayWay: function (item, index) {
                let self = this;
                for(let i = 0; i < self.payWayList.length; i++) {
                    if(i == index) {
                        self.servcOrder.payWay = item.value;
                    }
                }
                self.servcOrder = Utils.merge({}, self.servcOrder);
            },
            //选择发票的主体类型
            changPayTiming: function (item, index) {
                let self = this;
                for(let i = 0; i < self.payTimingList.length; i++) {
                    if(i == index) {
                        self.servcOrder.payTiming = item.value;
                    }
                }
                self.servcOrder = Utils.merge({}, self.servcOrder);
            },
            //选择收货时段
            changRecvFrame: function (item, index) {
                let self = this;
                for(let i = 0; i < self.recvFrameList.length; i++) {
                    if(i == index) {
                        self.servcOrder.recvFrame = item.value;
                    }
                }
                self.servcOrder = Utils.merge({}, self.servcOrder);
            },
            //选择对应的发票类型
            changInvoiceTypeType: function (item, index) {
                let self = this;
                for(let i = 0; i < self.invoiceTypeList.length; i++) {
                    if(i == index) {
                        if(!Utils.isNoB(self.servcOrder.buyerId)) {
                            self.servcOrder.invoiceType = item.value;
//                            self.selectInvoiceSubject(self.servcOrder.buyerId, self.servcOrder.buyerType, self.servcOrder.invoiceType);
                        } else {
                            MsgBox.warning("请选择对应的买家信息")
                            return;
                        }
                    }
                }
                self.servcOrder = Utils.merge({}, self.servcOrder);
            },
            //选择主体类型
            changInvoiceSubjectType: function (item, index) {
                let self = this;
                for(let i = 0; i < self.invoiceSubjectTypeList.length; i++) {
                    if(i == index) {
                        self.servcOrder.invoiceSubjectType = item.value;
                    }
                }
                self.servcOrder = Utils.merge({}, self.servcOrder);
            },
            //选择内容标签
            changInvoiceContentTag: function (item, index) {
                let self = this;
                for(let i = 0; i < self.invoiceContentTagList.length; i++) {
                    if(i == index) {
                        self.servcOrder.invoiceContentTag = item.name;
                    }
                }
                self.servcOrder = Utils.merge({}, self.servcOrder);
            },
            //提交订单
            submitClick: function () {
                let self = this;
                this.$refs['ruleForm'].validate(function (valid) {
                    if(valid) {
                        let servcOrder = self.servcOrder;
                        servcOrder.invoiceClaimed = false;
                        servcOrder.payMode = servcOrder.payTiming;
                        servcOrder.planTime = self.planTime.format("yyyy-MM-dd HH:mm");
                        servcOrder.submitted = true;
                        let trackPhaseList = self.trackPhaseList;
                        if(!Utils.isNoB(self.contractId) && trackPhaseList != null && trackPhaseList.length > 0) {
                            servcOrder.trackPhaseId = self.trackPhaseId;
                            for(let i = 0; i < trackPhaseList.length; i++) {
                                let trackPhase = trackPhaseList[i];
                                if(self.trackPhaseId == trackPhase.id) {
                                    servcOrder.trackPhaseName = trackPhase.name;
                                }
                            }
                        }
                        if(!Utils.isNoB(self.contractId) && trackPhaseList != null && trackPhaseList.length > 0 && Utils.isNoB(self.trackPhaseId)) {
                            MsgBox.warning("请选择合同阶段");
                            return;
                        }
                        let servcOrderItemList = [];
                        if(servcOrder.servcOrderItemList.length <= 0) {
                            MsgBox.warning("请添加服务");
                            return false;
                        }
                        for(let i = 0; i < servcOrder.servcOrderItemList.length; i++) {
                            let servOrderItem = servcOrder.servcOrderItemList[i];
                            if(servOrderItem.checked) {
                                servcOrderItemList.push(servOrderItem);
                            }
                        }
                        for(let i = 0; i < servcOrderItemList.length; i++) {
                            let servOrderItem = servcOrderItemList[i];
                            // 判断 服务次数
                            let quantity = servOrderItem.quantity;
                            let usedQuantity = servOrderItem.usedQuantity;
                            if(usedQuantity >= quantity) {
                                MsgBox.warning("【" + servOrderItem.name + "】服务次数已经用尽！");
                                return;
                            }
                        }
                        if(servcOrderItemList.length <= 0) {
                            MsgBox.warning("请选择对应的服务");
                            return false;
                        }
                        if(Utils.isNoB(self.servcOrder.buyerShopId)) {
                            MsgBox.warning("请选择零售机构");
                            return;
                        }
                        servcOrder.servcOrderItemList = Utils.merge([], servcOrderItemList);
                        //
                        let lastMsgBoxDlg = MsgBox.loading();
                        servcOrderApi.saveServcOrder(servcOrder, function (reault) {
                            lastMsgBoxDlg.close();
                            if(reault.type == 'info') {
                                MsgBox.success("保存成功");
                                if(Utils.isNoB(self.contractId)) {
                                    self.returnSelfOrder();
                                } else {
                                    self.returnContractOrder();
                                }
                            } else {
                                MsgBox.warning(reault.message);
                            }
                        });
                    } else {
                        MsgBox.warning("请填写必须信息");
                        return false;
                    }
                });
            },
            returnContractOrder: function () {
                let self = this;
                let contractId = self.contractId;
                this.$router.push({
                    path: SwbContractServcOrderList.path,
                    query: {
                        contractId: contractId,
                    }
                });
            },
            returnSelfOrder: function () {
                this.$router.push({
                    path: SwbServcOrderIsSelfList.path,
                });
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/servcOrder/ServcOrderCreate.vue